<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" appendTo="body"
          [style]="{'width': '700px', 'height': '700px'}" [resizable]="false">

	<p-header>
		<span>Select Device</span>
	</p-header>
	
	<div style="overflow: hidden;">

		<!-- Search Box-->
		<div style="padding:4px 10px; border-bottom: 0 none">
			<i class="fa fa-filter" style="margin:4px 4px 0 0"></i>
			<input type="text" pInputText size="50" placeholder="Filter" [(ngModel)]="searchText"
				(input)="tt.filterGlobal($event.target.value, 'contains')" style="width:auto">
		</div>

		<div style="height: 10px;">&nbsp;</div>

		<!-- Data table -->
		<p-table #tt [value]="deviceList" [columns]="cols" [globalFilterFields]="['displayName', 'ipAddress', 'macAddress']"
				[scrollable]="true" scrollHeight="500px" [resizableColumns]="true" dataKey="deviceGuid"
				selectionMode="single" [(selection)]="selectedDevice">

			<ng-template pTemplate="header">
				<tr>
					<th pResizableColumn>Device Name</th>
					<th pResizableColumn>IP Address</th>
					<th pResizableColumn>MAC Address</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-rowData>
				<tr [pSelectableRow]="rowData" (dblclick)="onDeviceSelected(rowData)" class="uv-table-row">
					<td>
						<span class="uv-table-value">{{ rowData.displayName }}</span>
					</td>
					<td>
						<span class="uv-table-value">{{ rowData.ipAddress }}</span>
					</td>
					<td>
						<span class="uv-table-value">{{ rowData.macAddress }}</span>
					</td>
				</tr>
			</ng-template>
		</p-table>

	</div>

    <p-footer>
        <button type="button" pButton icon="fa fa-check" [disabled]="!enableOkButton" (click)="onOkClicked()" label="OK"></button>
		<button type="button" pButton icon="fa fa-check" [disabled]="false" (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>

</p-dialog>
